import { render, staticRenderFns } from "./IconPoint.vue?vue&type=template&id=5744653e&scoped=true"
import script from "./IconPoint.vue?vue&type=script&lang=js"
export * from "./IconPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5744653e",
  null
  
)

export default component.exports